import { DEFAULT_ROUTE_AFTER_LOGIN } from "@/constants";
import { AuthMachineContext } from "@/store/machine/authMachine/authMachine";
import { useUserStore } from "@/store/user";
import { useEffect } from "react";
import { useLocation, useRoute } from "wouter";

export const SignUpPage = () => {
  const [isLoginPage, pageParams] = useRoute("/login/:section?");
  const setRequiresLoginModalOpen = useUserStore((state) => state.setRequiresLoginModalOpen);
  const setRequiresLoginMode = useUserStore((state) => state.setRequiresLoginMode);
  const isLoggedIn = AuthMachineContext.useSelector((state) => state.context.isLoggedIn);
  const [, setLocation] = useLocation();

  useEffect(() => {
    setRequiresLoginMode("default");
    setRequiresLoginModalOpen(true);

    return () => {
      setRequiresLoginModalOpen(false);
    };
  }, [setRequiresLoginModalOpen, setRequiresLoginMode, isLoginPage, pageParams?.section]);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    setLocation(DEFAULT_ROUTE_AFTER_LOGIN);
  }, [isLoggedIn, setLocation]);

  return <div className="flex flex-col flex-1">

  </div>
};

export default SignUpPage;
